module.exports = __webpack_public_path__ + "img/default_nocontent.9b3882a1.png";